import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'
import { Stack } from '../../../../components/Stack'
import {
  HeroContent,
  HeroRoot,
  HeroVideoSubtitle,
  HeroTitle,
  HeroVideo,
  HeroVideoContainer,
} from './Hero.styles'
import { PrimaryButton } from '../../OurStory.styles'

export const Hero = () => {
  const { t } = useTranslation()

  return (
    <HeroRoot>
      <HeroContent>
        <HeroTitle>{t('our-story:hero.title')}</HeroTitle>
        <HeroVideoContainer>
          <HeroVideo>
            <iframe
              src="https://www.youtube.com/embed/UDkesyJBHPs?si=FMusjU31uinMhAru"
              title="A note from our Co-founder"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </HeroVideo>
          <Stack
            justifyContent="center"
            direction={{ '@initial': 'column', '@bp2': 'row' }}
            gap="0"
            alignItems="center"
          >
            <HeroVideoSubtitle>
              {t('our-story:hero.video-subtitle-part-1')}{' '}
              <b>{t('our-story:hero.video-name-subtitle-bold')}</b>
              {t('our-story:hero.video-subtitle-part-2')}
            </HeroVideoSubtitle>
          </Stack>
        </HeroVideoContainer>
        <Link href="/meal-plan">
          <PrimaryButton>{t('our-story:hero.button')}</PrimaryButton>
        </Link>
      </HeroContent>
    </HeroRoot>
  )
}
